<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<div class="pcard" *ngIf="!isLoading">
  <h2>
    <i class="fa-solid fa-address-book"></i> My Contacts
    <span class="count">{{ myContacts.length }}</span>
  </h2>

  <div class="cgrid" *ngIf="myContacts.length > 0">
    <div class="citem" *ngFor="let contact of myContacts">
      <img [src]="photo(contact.user)" (error)="onImgError($event)" class="cav" alt="" />
      <b class="cname">{{ contact.user.firstname }} {{ contact.user.lastname }}</b>
      <small class="csub">{{ sub(contact.user) }}</small>
      <span class="tag" [class.ok]="contact.status === 'Accepted'">{{ contact.status }}</span>
      <button type="button" class="btn-pink sm" *ngIf="contact.status === 'Accepted'" (click)="sendMessage(contact.id)">
        <i class="fa-solid fa-comment"></i> Send Message
      </button>
    </div>
  </div>

  <p class="empty" *ngIf="myContacts.length === 0 && !loadFailed">No contacts yet.</p>
  <p class="empty" *ngIf="loadFailed">Could not load contacts.</p>
</div>
